import * as API from '../api/PromoApi';

export function getAllPromo(token = null) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.getAllPromo(token);
}

export function createPromo(code) {
  const {start,end,...rest} = code;
  return API.createPromo(rest);
}

export function updatePromo(code) {
  const {start,end,...rest} = code;
  return API.updatePromo(rest);
}
